import { tv } from '@change/ds-utils';

export const sectionContainer = tv({
	base: 'flex flex-col gap-5',
});

export const titleContainer = tv({
	base: 'flex flex-col gap-2',
});

export const descriptionContainer = tv({
	base: 'flex flex-col gap-2',
});

export const endorsementCardContainer = tv({
	base: 'flex flex-col gap-6',
});

export const actionButtonsContainer = tv({
	base: 'flex items-center gap-4',
});
